import { intlMessageFormat } from 'LOCALES';

export default {
  publisher: {
    videoDefault: {
      frameRate: 15,
      insertDefaultUI: false,
      name: 'not_implemented',
      publishAudio: true,
      publishVideo: true,
      audioFallbackEnabled: true,
    },
    screenDefault: {
      name: intlMessageFormat('screenshare'),
      videoSource: 'screen',
      insertDefaultUI: false,
      publishAudio: true,
      publishVideo: true,
      audioFallbackEnabled: false,
    },
  },
  subscriber: {
    default: {
      insertDefaultUI: false,
      subscribeToAudio: true,
      subscribeToVideo: true,
    },
  },
};
